
<div v-if="visible" ref="alert" class="cp-alert">
  <div class="box-mask">
    <div class="box-container">
      <div class="box-content" v-html="text"></div>
      <div class="box-bottom">
        <div class="bottom-item" :class="{draw: title === 'draw'}" @click="onConfirm"></div>
      </div>
      <Close is-mobile @close="onClose" class="close"></Close>
    </div>
  </div>
</div>
